import { Component,OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';

/**
 * 	 <WorkEffortPurposeType description="Social Media Post" hasTable="N" workEffortPurposeTypeId="SOCIAL_MEDIA_POST"/>
	 <WorkEffortPurposeType description="Facebook Product Post" parentTypeId="SOCIAL_MEDIA_POST" hasTable="N" workEffortPurposeTypeId="FACEB_PROD_POST"/>
	 <WorkEffortPurposeType description="X/Twitter Product Post" parentTypeId="SOCIAL_MEDIA_POST" hasTable="N" workEffortPurposeTypeId="X_PROD_POST"/>
	 <WorkEffortPurposeType description="Instagram Product Post" parentTypeId="SOCIAL_MEDIA_POST" hasTable="N" workEffortPurposeTypeId="INSTA_PROD_POST"/>
	 <WorkEffortPurposeType description="LinkedIn Product Post" parentTypeId="SOCIAL_MEDIA_POST" hasTable="N" workEffortPurposeTypeId="LINK_PROD_POST"/>
	 <WorkEffortPurposeType description="Facebook Blog Article Post" parentTypeId="SOCIAL_MEDIA_POST" hasTable="N" workEffortPurposeTypeId="FACEB_ART_POST"/>
	 <WorkEffortPurposeType description="X/Twitter Blog Article Post" parentTypeId="SOCIAL_MEDIA_POST" hasTable="N" workEffortPurposeTypeId="X_ART_POST"/>
	 <WorkEffortPurposeType description="Instagram Blog Article Post" parentTypeId="SOCIAL_MEDIA_POST" hasTable="N" workEffortPurposeTypeId="INSTA_ART_POST"/>
	 <WorkEffortPurposeType description="LinkedIn Blog Article Post" parentTypeId="SOCIAL_MEDIA_POST" hasTable="N" workEffortPurposeTypeId="LINK_ART_POST"/>
 */

export enum WorkEffortPurposeType {
  FACEB_PROD_POST = "facebookProductPost",
  X_PROD_POST = "xProductPost",
  INSTA_PROD_POST = "instgramProductPost",
  LINK_PROD_POST = "linkedInProductPost",
  FACEB_ART_POST = "facebookArtPost",
  X_ART_POST = "xArtPost",
  INSTA_ART_POST = "instgramArtPost",
  LINK_ART_POST = "linkedInArtPost"
}

@Component({
  selector: 'ngx-calendar-dialog',
  templateUrl: './calendar-dialog.component.html',
  styleUrls: ['./calendar-dialog.component.scss'],
})
export class CalendarDialogComponent implements OnInit{
  data:any;
  view: WorkEffortPurposeType;
  baseUrl:string;
  objectInfo:string;
  imageBaseUrl:string;
  imageUrl:string;
  
  constructor(
    protected dialogRef: NbDialogRef<CalendarDialogComponent>
  ) {}

  ngOnInit():void{
    console.log(this.data)
    console.log(this.baseUrl)
    this.view = this.data.workEffortPurposeTypeId;
    this.objectInfo = this.data.metaDataValue2;
    this.baseUrl = this.data.baseUrl;
    //this.imageUrl = this.imageBaseUrl+this.objectInfo;
    this.imageUrl = this.baseUrl+this.objectInfo;
  }

  onSubmit(){
  }

  onFileChange(e){

  }

}
